import React from "react";
import artistsImgar from "../../../assets/II Website Image - Artist Headshots.webp";
// import chartImg from "../../../assets/CHARTS_updated_2.webp";
import chartImg from "../../../assets/chartImg.png";
// import chartBg from "../../../assets/Chart_Accredited.webp";

const Artists = () => {
  return (
    <div className="artists pt-[50px] pb-[100px]">
      <div className="container mx-auto">
        <div className="flex lg:flex-row flex-col justify-between items-start gap-10">
          <div className="w-full lg:w-[45%] pt-[50px]">
            <p
              className="uppercase text-sm font-semibold"
              style={{ letterSpacing: 1 }}
            >
              A platform you can trust
            </p>
            <h2
              className="text-[40px] font-bold mt-1"
              style={{ lineHeight: "1.2" }}
            >
              We white label <br />{" "}
              <span className="besley font-normal italic">our platform </span> to enterprise {" "} <br />  clients and work with artists and
              companies of all sizes.
            </h2>
          </div>
          <div className="w-full lg:w-[50%] bg-white p-5 rounded-md shadow-2xl">
            <img src={artistsImgar} alt="" />
          </div>
        </div>
        <div className="flex justify-between flex-col lg:flex-row-reverse items-start gap-10 mt-[50px] lg:mt-[150px]">
          <div className="w-full lg:w-[45%] pt-[20px]">
            <p
              className="uppercase text-sm font-semibold"
              style={{ letterSpacing: 1 }}
            >
              Our most popular
            </p>
            <h2
              className="text-[40px] font-bold mt-1"
              style={{ lineHeight: "1.2" }}
            >
              Client Use Cases
            </h2>

            <ul className="chart-ul mt-5">
              <li className="text-[30px] font-bold flex items-center gap-2">
                Trading Cards
              </li>
              <li className="text-[30px] font-bold flex items-center gap-2">
                Product Packaging
              </li>
              <li className="text-[30px] font-bold flex items-center gap-2">
                Event Laminates
              </li>
              <li className="text-[30px] font-bold flex items-center gap-2">
                Posters & Signage
              </li>
              <li className="text-[30px] font-bold flex items-center gap-2">
                Tour Books & Wedding Albums
              </li>
              <li className="text-[30px] font-bold flex items-center gap-2">
                Vinyl Records
              </li>
              <li className="text-[30px] font-bold flex items-center gap-2">
                Athletic & School Portraits
              </li>
            </ul>
          </div>
          <div className="w-full lg:w-[50%] bg-white rounded-md shadow-2xl relative">
            <img src={chartImg} className="w-full left-[-5%]" alt="" />
            {/* <img src={chartBg} alt="" /> */}
          </div>
        </div>
        <div className="flex lg:flex-row flex-col justify-between items-start gap-10 mt-[50px] lg:mt-[150px]">
          <div className="w-full lg:w-[45%] pt-[50px]">
            <p
              className="uppercase text-sm font-semibold"
              style={{ letterSpacing: 1 }}
            >
             We Help
            </p>
            <h2
              className="text-[40px] font-bold mt-1"
              style={{ lineHeight: "1.2" }}
            >
              Some of the  <br />{" "}
              <span className="besley font-normal italic">
              world’s biggest artists
              </span>{" "}
              <br /> connect with their fans  <br />
              using our platform for video messages
            </h2>
          </div>
          <div className="w-full lg:w-[50%] bg-white p-5 rounded-md shadow-2xl">
            <img src={artistsImgar} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Artists;
